export const CNPJ_MASK = '99.999.999/9999-99';
// Aceita CNPJ em dois formatos: 14 digitos crus OU mascarado
// (00.000.000/0000-00). PO pode entregar o ngModel em qualquer um dos dois
// dependendo de p-mask-format-model - manter o pattern tolerante evita
// falsos negativos por config.
export const CNPJ_PATTERN = '^(\\d{14}|\\d{2}\\.\\d{3}\\.\\d{3}/\\d{4}-\\d{2})$';

export function onlyDigits(value: string | null | undefined): string {
  return (value ?? '').replace(/\D+/g, '');
}

/**
 * Valida CNPJ por digitos verificadores.
 * Aceita entrada com ou sem mascara.
 */
export function isValidCnpj(value: string | null | undefined): boolean {
  const cnpj = onlyDigits(value);
  if (cnpj.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  const digits = cnpj.split('').map(Number);
  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const calc = (weights: number[]): number => {
    const sum = weights.reduce((acc, w, i) => acc + w * digits[i], 0);
    const rem = sum % 11;
    return rem < 2 ? 0 : 11 - rem;
  };

  return calc(weights1) === digits[12] && calc(weights2) === digits[13];
}
